import axios from 'axios'
import { unsafeGetToken } from '../ducks/auth'

export const request = (datasourceId, url, method = 'get', data) => {
  let config = {
    method,
    url,
    data,
  }

  let token = unsafeGetToken(datasourceId)

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    }
  }

  return axios(config)
}
